const route = [
  {
    path: "/task/list/:tenant",
    name: "task",
    component: () => import("@/views/task/index"),
    meta: { routeName: "任务中心", unGetUser: true },
  },
  {
    path: "/task/details",
    name: "taskDetails",
    component: () => import("@/views/task/details"),
    meta: { routeName: "任务详情", unGetUser: true },
  },
  {
    path: "/task/create/:tenant/:type",
    name: "CreatTask",
    component: () => import("@/views/task/create"),
    meta: { routeName: "创建任务", unGetUser: true },
  },
  {
    path: "/task/create/:tenant/:type/:taskId",
    name: "CreatTask",
    component: () => import("@/views/task/create"),
    meta: { routeName: "编辑任务", unGetUser: true },
  },
];
export default route;
